window['ThemeSection_Product'] = ({
  product,
  variant,
  featuredMediaID,
  template,
  thumbnailsPosition,
  showThumbnailsOnMobile,
}) => {
  return {
    productRoot: null,
    product: product,
    current_variant: variant,
    featured_media_id: featuredMediaID,
    current_media_id: featuredMediaID,
    loading: false,
    quantity: '1',
    options: [],
    optionHandles: [],
    storeAvailability: null,
    addedToCart: false,
    stickyAddToCartShown: false,
    template: template,
    thumbnailsPosition: thumbnailsPosition,
    showThumbnailsOnMobile: showThumbnailsOnMobile,
    subscriptionPriceMultiplier: 1,
    get addToCartText() {
      if (this.current_variant) {
        if (this.loading) {
          return window.theme.strings.loading;
        }
        if (!this.loading && this.current_variant.available) {
          if (this.template === 'product.preorder') {
            return window.theme.strings.preOrder;
          } else {
            return window.theme.strings.addToCart;
          }
        }
        if (!this.loading && !this.current_variant.available) {
          return window.theme.strings.soldOut;
        }
      } else {
        return window.theme.strings.unavailable;
      }
    },
    get currentVariantId() {
      if (this.current_variant) {
        return this.current_variant.id;
      } else {
        return null;
      }
    },
    get currentVariantAvailabilityClosestLocation() {
      // this is on a lag to the actual current variant so that we can display an intermediary state while the fetch request is happening
      if (!Alpine.store('availability')) return null;

      const id = this.currentVariantId;
      const storeData = Alpine.store('availability').availability[id];
      if (storeData) {
        return storeData.closest_location;
      } else {
        return null;
      }
    },
    get currentVariantAvailable() {
      if (this.current_variant) {
        return this.current_variant.available;
      } else {
        return null;
      }
    },
    get currentVariantTitle() {
      if (this.current_variant && this.current_variant.title) {
        if (!this.current_variant.title.includes('Default')) {
          return this.current_variant.title;
        }
      }
      return '';
    },
    // SV- avoid crash when no variant match; apply subscription multiplier
    get current_price() {
      let base;
      if (this.current_variant) {
        base = this.current_variant.price;
      } else {
        base = this.product?.variants?.[0]?.price ?? 0;
      }
      const mult = this.subscriptionPriceMultiplier ?? 1;
      return Math.round(base * mult);
    },
    get isUsingSlideshowToDisplayMedia() {
      const splideEl = this.productRoot.querySelector('.splide--product');

      if (window.Splide && this.productRoot && splideEl) {
        if (
          window.slideshows &&
          window.slideshows[`${splideEl.id}`] &&
          !window.slideshows[`${splideEl.id}`].state.is(
            window.Splide.STATES.DESTROYED
          )
        ) {
          return true;
        }
      }

      return false;
    },
    formatMoney(price) {
      return formatMoney(price, theme.moneyFormat);
    },
    init() {
      // Set a product root for nested components
      // to use instead of $root (which refers to their root)
      this.productRoot = this.$root;

      // SV- sync subscription discount with btn-price Alpine binding
      this.$el.addEventListener('sv-subscription-pricing', (e) => {
        this.subscriptionPriceMultiplier = e.detail?.multiplier ?? 1;
      });

      if (this.$refs.productForm) {
        this.$refs.productForm.addEventListener(
          'submit',
          this.submitForm.bind(this)
        );
      }

      this.getOptions();
      this.getAddToCartButtonHeight();

      this.$watch('current_media_id', (value, oldValue) => {
        if (showThumbnailsOnMobile) {
          this.$root.dispatchEvent(
            new CustomEvent('shapes:product:mediachange', {
              bubbles: true,
              detail: {
                media_id: this.current_media_id,
                slideshow_id:
                  this.productRoot.querySelector('.splide--product')?.id,
              },
            })
          );
        }
        if (this.isUsingSlideshowToDisplayMedia) return;
        if (this.$root
          .querySelector(`[data-product-single-media-wrapper="${oldValue}"]`)) {
          this.$root
            .querySelector(`[data-product-single-media-wrapper="${oldValue}"]`)
            .dispatchEvent(new CustomEvent('mediaHidden'));
        }

        if (this.$root
          .querySelector(`[data-product-single-media-wrapper="${value}"]`)) {
          this.$root
            .querySelector(`[data-product-single-media-wrapper="${value}"]`)
            .dispatchEvent(new CustomEvent('mediaVisible'));
        }
      });

      this.updateStoreAvailability(this.current_variant);
    },
    getAddToCartButtonHeight() {
      window.onload = function () {
        const height = document.querySelector('.add-to-cart-btn').offsetHeight;
        document.documentElement.style.setProperty(
          '--payment-button-height',
          `${height}px`
        );
      };
    },
    updateStoreAvailability(variant) {
      if (!this.$refs.storeAvailabilityContainer) return;
      this.storeAvailability =
        this.storeAvailability ||
        new StoreAvailability(this.$refs.storeAvailabilityContainer);

      if (this.storeAvailability && variant) {
        this.storeAvailability.fetchContent(variant);
      }
    },
    optionChange() {
      this.getOptions();

      const matchedVariant = ShopifyProduct.getVariantFromOptionArray(
        this.product,
        this.options
      );

      this.current_variant = matchedVariant; 

      if (this.current_variant) {
        variantLiveRegion(this.current_variant);
        this.updateStoreAvailability(this.current_variant);

        if (this.current_variant.featured_media) {
          this.current_media_id = this.current_variant.featured_media.id;
        }
        const url = ShopifyProductForm.getUrlWithVariant(
          window.location.href,
          this.current_variant.id
        );

        window.history.replaceState({ path: url }, '', url);

        const sectionId = document.querySelector('#product-media').getAttribute('data-section');

        // console.log(this.featured_media_id)
        // SV- fetch new media HTML and replace existing media 
        if (document.querySelector('#product-media').dataset.variantSpecificMedia == 'true') {
          (async() => {
            // capture the variant id as cart attribute
            await u_UpdateCartAttributes({
              _last_viewed_variant_id: this.current_variant.id
            });
            
            let res = await fetch(`${url}?section_id=${sectionId}`);
            let responseText = await res.text();
            const html = new DOMParser().parseFromString(responseText, 'text/html');

            let $new_media = html.querySelector('#product-media');
            let $splide_product = $new_media.querySelector('.splide--product');
            $splide_product.id = `${$splide_product.id}-${Date.now()}`;
            let $splide_thumbnails = $new_media.querySelector('.splide--thumbnails');
            $splide_thumbnails.id = `${$splide_thumbnails.id}-${Date.now()}`;
            $splide_product.setAttribute('data-thumbnails', $splide_thumbnails.id);

            document.querySelector('#product-media').innerHTML = $new_media.innerHTML;
            this.featured_media_id = parseInt($new_media.getAttribute('data-featured_media_id'));
            this.current_media_id = this.featured_media_id;

            let $photoswipeComponent = document.querySelector('[x-ref="photoSwipeComponent"]');
            if ($photoswipeComponent) {
              $photoswipeComponent.innerHTML = html.querySelector('[x-ref="photoSwipeComponent"]').innerHTML;
            }

            // Remove cart attribute after rendering new media
            await u_UpdateCartAttributes({
              _last_viewed_variant_id: null
            });

            // Reinitialize product media gallery
            window.discoverNewSlideshows();
          })();
        }
        // End SV-

        this.$refs.singleVariantSelector.dispatchEvent(
          new Event('change', { bubbles: true })
        );
        this.$root.dispatchEvent(
          new CustomEvent('shapes:product:variantchange', {
            bubbles: true,
            detail: { variant: this.current_variant, firstImage: 26517388296215 },
          })
        );
      }
    },
    getOptions() {
      this.options = [];
      this.optionHandles = [];

      let selectors = this.$root.querySelectorAll(
        '[data-single-option-selector]'
      );

      selectors.forEach((selector) => {
        if (selector.nodeName === 'SELECT') {
          const value = selector.value;
          this.options.push(value);
          this.optionHandles.push(
            selector.options[selector.selectedIndex].dataset.handle
          );
        } else {
          if (selector.checked) {
            console;
            const value = selector.value;
            this.options.push(value);
            this.optionHandles.push(selector.dataset.handle);
          }
        }
      });
    },
    changeMedia(direction) {
      this.$root.dispatchEvent(
        new CustomEvent('shapes:product:arrow-change', {
          bubbles: true,
          detail: { direction: direction },
        })
      );
      if (this.thumbnailsPosition == 'under') {
        const currentThumbnail = this.$root.querySelector(
          '.product-thumbnail-list-item--active'
        );
        const nextElement =
          direction == 'prev'
            ? currentThumbnail.previousElementSibling
            : currentThumbnail.nextElementSibling;
        if (nextElement !== null) {
          nextElement.querySelector('.media-thumbnail').click();
        }
      }
    },
    submitForm(evt) {
      evt.preventDefault();
      this.loading = true;

      liveRegion(window.theme.strings.loading);

      const formData = new FormData(this.$refs.productForm);

      let modalCart = theme.settings.cart_type === 'modal';

      const config = fetchConfigDefaults('javascript');

      if (modalCart) {
        formData.append('sections', 'cart-items,cart-footer,cart-item-count');
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;

      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      fetch(`${theme.routes.cart_add_url}`, config)
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            this.loading = false;
            throw data.description;
          }
          this.loading = false;
          this.addedToCart = true;

          if (modalCart) {
            document.body.dispatchEvent(
              new CustomEvent('shapes:modalcart:afteradditem', {
                bubbles: true,
                detail: { response: data },
              })
            );
          }

          if (!document.querySelector('[data-show-on-add="true"]')) {
            if (this.$refs.added)
              this.$nextTick(() => this.$refs.added.focus());
          }
        })
        .catch((error) => {
          if (typeof error === 'string') {
            alert(error);
          } else {
            error.json().then((a) => {
              this.loading = false;
              alert(a.description);
            });
          }
        });
    },
    openZoom(id) {
      const imageZoomDataEl = this.productRoot.querySelector(
        '[data-photoswipe-images]'
      );

      if (!imageZoomDataEl) return;

      const imageZoomData = JSON.parse(imageZoomDataEl.innerHTML);

      const imageMediaIDsArray = Object.keys(imageZoomData);

      const index = imageMediaIDsArray.indexOf(id);

      this.$refs.photoSwipeComponent.dispatchEvent(
        new CustomEvent('shapes:photoswipe:open', {
          detail: {
            index: index,
          },
        })
      );
    },
  };
};

window['productThumbnails'] = () => {
  return {
    firstVisible: true,
    lastVisible: false,
    mounted() {
      const firstThumbnail = this.$refs.firstThumbnail;
      const lastThumbnail = this.$refs.lastThumbnail;
      const options = {
        root: this.$root.querySelector('.splide__track'),
        rootMargin: '0px',
        threshold: 1.0,
      };
      const firstThumbnailObserver = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.firstVisible = true;
          } else {
            this.firstVisible = false;
          }
        },
        options
      );
      const lastThumbnailObserver = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.lastVisible = true;
          } else {
            this.lastVisible = false;
          }
        },
        options
      );
      firstThumbnailObserver.observe(firstThumbnail);
      lastThumbnailObserver.observe(lastThumbnail);
    },
  };
};

/*
checkYopto();
function checkYopto(){
 var times = 1
 if (document.querySelector('[name="selling_plan"]') 
     && document.querySelector('.yotpo-radio-subscription-container .yotpo-subscription-label-price')
    && document.querySelector('.yotpo-radio-buy-once-container .yotpo-subscription-label-price')) {
    initial();
  } else {
    if(times < 2000){
      setTimeout(() => {
         times++;
        console.log(times);
        checkYopto();
      }, 500);
    }
  };
}
function initial(){
  debugger;
  var subscription_price, original_price;
  if(document.querySelector('.yotpo-radio-subscription-container [name="selling_plan"]:checked')){
      subscription_price = document.querySelector('.yotpo-radio-subscription-container .yotpo-subscription-label-price').innerText.substring(1);
      original_price = document.querySelector('.yotpo-radio-buy-once-container .yotpo-subscription-label-price').innerText.substring(1);
      updatePriceInAddBtn();
  }
  document.addEventListener('click', function(e){
    if(e.target.classList.contains('yotpo-radio-button-text-wrapper') 
       || e.target.closest('.yotpo-radio-button-text-wrapper') 
    ){
      updatePriceInAddBtn();
    }
  })
  function updatePriceInAddBtn(){
    debugger;
    var price;
    if(document.querySelector('.yotpo-radio-subscription-container [name="selling_plan"]:checked')){
      price = subscription_price;
    }else{
      price = original_price;
    }
    var quantity = document.querySelector('[name="quantity"]').value;
    var total_price = "$" + ((quantity * 1) * price).toFixed(2);
    console.log(total_price);
    if(isNaN(price)){
      return;
    }else{
      document.querySelector('.add-to-cart-btn [x-html="formatMoney(current_price)"]').innerText = total_price;
      return total_price;
    }

  }
  document.querySelector('[name="quantity"]').addEventListener('change',function(e){
    setTimeout(() => {
      var quantity = document.querySelector('[name="quantity"]').value;
      updatePriceInAddBtn();
      document.querySelectorAll('.yotpo-subscription-label-price').forEach(item=>{
        if(item.closest('.yotpo-radio-subscription-container')){
          var total_price = "$" + ((quantity * 1) * subscription_price).toFixed(2);
          item.innerText = total_price ;
        }else{
          var total_price = "$" + ((quantity * 1) * original_price).toFixed(2);
          item.innerText = total_price ;
        }
        
      })
    }, 100);
  })

}
*/